/** @jsx jsx */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Column } from 'react-table';
import { css, jsx } from '@emotion/core';
import OrganizationDomain from 'domain/organization';
import DataTable from 'components/organismos/DataTable/DataTable';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import Modal from 'components/molecules/Modal';
import StoreCloseFilter from './StoreCloseFilter';
import ButtonNavigation from './ButtonNavigation';
import { useOrganizationDelete, useDownload } from './hooks';
import FormPadding from 'components/atoms/Form/FormPadding';
import { InfoButton } from 'components/atoms/Button';
import { Link } from 'react-router-dom';
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

const OrganizationListTable:React.FC<{
    organizationList: Array<OrganizationDomain>;
    fetchData: () => Promise<void>;
    noManager: boolean;
    toggleNoManager: () => void;
    unsetTargetDate: Date;
    setUnsetTargetDate: (arg: Date) => void;
    orgStatus: string;
    setOrgStatus : (art: '0'|'1') => void;
}> = ({
  organizationList, noManager, toggleNoManager,
  unsetTargetDate, setUnsetTargetDate, orgStatus, setOrgStatus,
}) => {
  const {
    deleteTargetOrganization, setDeleteTargetOrganization,
    isOpenDeleteModal,
    closeDeleteModal, onSubmitDeleteOrganization,
  } = useOrganizationDelete();
  const {
    downloadOrganization, downloadManagerCsv, downloadSpecialSalaryCsv,
  } = useDownload(noManager, orgStatus, unsetTargetDate);
  const isAuthorizedFromPeople = process.env.REACT_APP_IS_AUTHORIZED_FROM_PEOPLE === "true"|| false;
  
  const columns: Array<Column<OrganizationDomain>> = React.useMemo(() => [
    {
      Header: () => null,
      accessor: 'orgCode',
      id: 'actionButton',
      disableSortBy: true,
      Cell: (cell: { row :{ isExpanded: boolean, values: OrganizationDomain }}) => {
        const [isHoverEdit, setIsHoverEdit] = useState(false);
        return (
          <FlexBox customStyle={css({height: '0px'})}>
            <FlexBoxItem margin="0 auto">
              <span
                onMouseEnter={() => setIsHoverEdit(true)}
                onMouseLeave={() => setIsHoverEdit(false)}
              >
                <Link to={`/organizations/${cell.row.values.orgCode}`}>
                  <InfoButton 
                    text="編集" 
                    minWidth={'36px'}
                    customStyle={css({
                      padding: '0 5px', 
                      borderRadius: '3px', 
                      fontSize: '12px', 
                      lineHeight: '20px', 
                      height: '24px', 
                      fontFamily: "'Noto Sans',sans-serif" 
                    })}
                  /> 
                </Link>
              </span>
            </FlexBoxItem>
          </FlexBox>
        );
      },
    },
    {
      Header: '組織コード',
      accessor: 'orgCode',
    },
    {
      Header: '組織名',
      accessor: 'orgName',
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [setDeleteTargetOrganization]);

  return (
    <div>
      <FormPadding>
        <div css={css({ paddingBottom: '16px' })}>
          <StoreCloseFilter
            orgStatus={orgStatus}
            setOrgStatus={setOrgStatus}
          />
        </div>
        <div css={css({ position: 'relative' })}>
          <ButtonNavigation 
            downloadOrganization={downloadOrganization}
            downloadManagerCsv={downloadManagerCsv}
            downloadSpecialSalaryCsv={downloadSpecialSalaryCsv}
          />
        </div>
      </FormPadding>
      <div
        css={css`
        table tr td:nth-child(1) button{
          white-space: nowrap;
        }
        table th:nth-of-type(1) {
          width: ${isIpad ? '12px' : '5px'};
        }        
        table th:nth-of-type(2) {
          width: 80px;
        }
        table th:nth-of-type(3) {
          width: 146px;
        }
        table th{
          text-align: center;
        }
      `}
      >
        <div
          className="table-bordered table-padding" 
          style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}
        >
          <DataTable 
            classNameParrant="border-left-right"
            className="table-no-border-left-right" 
            columns={columns} 
            data={organizationList} 
            isGlobalFilter={true} 
            minWidth="632px" 
            sortBy={[{id : 'orgCode', desc: true}, {id: 'orgName', desc: true}]} 
          />
        </div>
      </div>

      <Modal
        open={isOpenDeleteModal}
        closeHandler={closeDeleteModal}
        submitText="削除"
        title="削除"
        onSubmit={onSubmitDeleteOrganization}
      >
        {deleteTargetOrganization?.orgName}
        を削除します。よろしいですか？
      </Modal>
    </div>
  );
};

export default OrganizationListTable;
